<template>
  <v-container
    class="px-0 mx-0 mx-auto max-width-412"
  >
    <v-snackbar
      v-model="snackbar.active"
      :timeout="1920"
      color="accent"
      class="primary--text"
    >
      <div
        class="mx-auto"
        v-html="snackbar.text"
      />
    </v-snackbar>

    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text
          class="py-5"
        >
          <v-progress-linear
            indeterminate
            color="accent"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="active"
      persistent
      content-class="max-width-412"
    >
      <v-card
        class="pa-4 transparent"
        flat
      >
        <v-card-text
          v-for="(keys, i) in generators"
          :key="`generator-${i}`"
          class="my-4"
        >
          <v-text-field
            :id="`generator-${i}`"
            :value="keys"
            :label="i"
            color="primary"
            readonly
            hide-details
            append-outer-icon="mdi-content-copy"
            @click="copy(`generator-${i}`, i, keys)"
            @click:append-outer="copy(`generator-${i}`, i, keys)"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            dark
            fab
            @click="mount()"
          >
            <v-icon
              color="accent"
            >
              mdi-cached
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapActions } from "vuex"

  export default {
    data: function () {
      return {
        snackbar: {
          active: false,
          text: false,
        },

        generators: undefined,
        loading: true,
        active: false,
      }
    },

    mounted () {
      this.mount()
    },

    methods: {
      ...mapActions("Document", ["Generator"]),

      copy (id, i, key) {
        document.getElementById(id).select()
        document.execCommand("copy")

        this.snackbar.active = true
        this.snackbar.text = `${i}: ${key} copiado`
      },

      mount () {
        this.Generator()
          .then(response => {
            this.reload()
            setTimeout(() => {
              this.generators = response
            }, 960)
          })
      },

      reload () {
        this.loading = true
        this.active = false

        setTimeout(() => {
          this.loading = false
          this.active = true
        }, 1920)
      },
    },
  }
</script>
